
<template>
  <div v-loading="loading">
    <!--用户金额统计-->
    <Recharge v-if="!loading"></Recharge>
    <!--用户统计-->
    <Analysis v-if="!loading" style="min-height: 500px;"></Analysis>
    <!--排行榜-->
    <Ranking v-if="!loading"></Ranking>
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import Recharge from "./part/recharge.vue";
import Ranking from "./part/Ranking.vue";
import Analysis from "./part/Analysis.vue";

export default {
  components: {
    Recharge,
    Ranking,
    Analysis,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*数据对象*/
      dataModel: {}
    };
  },
  provide: function() {
    return {
      dataModel: this.dataModel
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      StatisticsApi.getUserTotal({}, true)
        .then(res => {
          Object.assign(self.dataModel, res.data);
          self.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>

<style scoped="scoped">
.statistics-member .bd-box {
  border-top: 1px solid #eeeeee;
}
.statistics-member .left-box {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user111/index.2.vue